import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

/**
 * Skeleton loader for Pivot Table
 */
const PivotTableSkeleton = () => {
  const { theme } = useTheme();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {[...Array(2)].map((_, cardIndex) => (
        <CustomCard key={cardIndex}>
          <div className="space-y-3">
            {/* Header */}
            <div className="h-5 w-32 bg-n200 rounded animate-pulse mb-4"></div>

            {/* Rows */}
            {[...Array(4)].map((_, rowIndex) => (
              <div key={rowIndex} className="flex items-center justify-between py-2">
                <div className="h-4 w-20 bg-n200 rounded animate-pulse"></div>
                <div className="h-4 w-24 bg-n200 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </CustomCard>
      ))}
    </div>
  );
};

export default PivotTableSkeleton;
